<template>
	<div class="group-box">
		<div class="works-name v-ellipsis">{{ worksName }}</div>
		<div v-if="worksType == 3" class="group">
			<div class="active">
				<i v-if="lists[0] && lists[0].id == activeGroupId" class="iconfont icon-flag v-mr-5"></i>
				<div>{{ remarkTime }}</div>
			</div>
			<i v-if="lists.length > 1" class="icon el-icon-caret-bottom"></i>
			<div v-if="lists.length > 1" class="list" :class="{hide:isHide}">
				<div v-for="(item,index) in lists" :key="item.id" :class="{ active : activeGroupId == item.id }" class="item" @click="changeGroup(item.id)">
					<i v-if="index == 0" class="iconfont icon-flag v-mr-5"></i>
					<div>{{ item.remarkTime }}</div>
				</div>
			</div>
		</div>
	</div>

</template>

<script>
	import {mapState, mapActions, mapMutations} from "vuex";

	export default {
		data() {
			return {
				lists: [],
				worksId: this.$route.query.id,
				worksType: this.$route.query.type,
				worksName: this.$route.query.name,
				isHide: false
			}
		},

		computed: {
			...mapState('tour', ['activeGroupId', 'workDetail']),
			remarkTime() {
				let active = this.lists.find(item => item.id == this.activeGroupId);
				return active ? active.remarkTime : ''
			}
		},

		created() {
			if (this.worksType == 3) {
				this.getList()
			}
		},

		methods: {

			...mapActions('tour', {
				actionGetGroupList: "getGroupList"
			}),

			...mapMutations('tour', {
				mutationUpdateGroupId: "UPDATE_ACTIVE_GROUP_ID",
				mutationUpdateIsShowViwer: "UPDATE_IS_SHOW_VIWER"
			}),

			async getList() {
				this.lists = await this.actionGetGroupList(this.worksId);
				this.mutationUpdateGroupId(this.lists[0].id)
			},

			changeGroup(groupId) {
				if (this.activeGroupId == groupId) {
					return
				}
				this.mutationUpdateIsShowViwer(false);
				this.mutationUpdateGroupId(groupId)
				this.isHide = true;
				setTimeout(() => {
					this.isHide = false;
				}, 100)
			}
		}
	}
</script>

<style scoped>
	.group-box{
		display: flex;
		align-items: center;
	}
	.works-name{
		width: 150px;
		text-align: center;
		padding: 0 10px;
	}
	.group {
		position: relative;
		width: 150px;
	}

	.group .active {
		height: 32px;
		display: flex;
		align-items: center;
		justify-content: center;
		cursor: pointer;
	}

	.group .active .iconfont {
		font-size: 12px;
		position: absolute;
		left: 15px;
		top: 50%;
		transform: translateY(-50%);
	}

	.group .icon {
		position: absolute;
		top: 50%;
		transform: translateY(-50%);
		right: 8px;
	}

	.group .list {
		position: absolute;
		width: 130px;
		left: 10px;
		bottom: 0;
		transform: translateY(100%);
		border: 1px solid #f5f5f5;
		border-radius: 4px;
		background: rgba(0, 0, 0, 0.7);
		padding: 0 10px;
		box-sizing: border-box;
		display: none;
	}

	.group:hover .list {
		display: block;
		max-height: 300px;
		overflow-y: auto;
	}

	.group .list.hide {
		display: none;
	}

	.group .list .item {
		height: 40px;
		display: flex;
		align-items: center;
		justify-content: center;
		border-top: 1px solid #f5f5f5;
		cursor: pointer;
		position: relative;
	}

	.group .list .item.active {
		color: #409eff;
		cursor: not-allowed;
	}

	.group .list .item:first-child {
		border-top: 0;
	}

	.group .list .item .iconfont {
		font-size: 12px;
		position: absolute;
		left: -5px;
		top: 50%;
		transform: translateY(-50%);
	}
</style>